import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { AppSettings } from '../shared/app-settings'
import { IUser } from './user';
import { tap } from 'rxjs/operators';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { ConfigService } from 'app/shared/config.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { IRecaptchaToken } from 'app/admin/interface/recaptcha-token.interface';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { environment } from 'environments/environment';


@Injectable()
export class LoginService {
    
    //private _logintUrl = AppSettings.logintUrl; //before changing the AppSettings.
   


    private apiUrl: string = "";

    constructor(private _http: Http,
                private _httpClient:HttpClient,
                private _spinnerService: SpinnerService,
                private _configService: ConfigService
                ) { 
                this.apiUrl = this._configService.getConfigPropertyByKey("apiUrl");
                }

    
    validateRecaptchav3(googleToken:string) : Observable<boolean>
    {  
        let token:IRecaptchaToken = {
            token:googleToken
        };
        
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<boolean>('https://pre-www5.tel-aviv.gov.il/TlvServices/ReCaptchaV3/api/ReCaptchaV3/ValidateReCaptchaV3',JSON.stringify(token.token),{headers:headers});
    }

    validateRecaptchav3InServer(googleToken:string) : Observable<ResultOfOperation<any>>
    {  
        let token:IRecaptchaToken = {
            token:googleToken
        };
        const headers = new HttpHeaders().set('Content-Type','application/json; charset=utf-8');
        return this._httpClient.post<ResultOfOperation<any>>(`${this.apiUrl}/api/login/ValidateRecaptchav3`,token,{headers:headers});
    }


    getLogin(username, password, captchatext,capuid, login_type): Observable<IUser> 
    {
        this._spinnerService.showSpinner();
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded');
        const data = 
            'username=' + encodeURIComponent(username) + 
            '&password=' + encodeURIComponent(password) + 
            '&grant_type=password'+
            '&captchatext=' + encodeURIComponent(captchatext)+ 
            '&capuid=' + encodeURIComponent(capuid) + 
            '&login_type=' + encodeURIComponent(login_type);
        const url = `${this._configService.getConfigPropertyByKey("loginUrl")}`;
        return this._httpClient.post<IUser>(url, data, { headers })
            .pipe(
                tap(
                    response => {
                        this._spinnerService.hideSpinner();
                    },
                    error => {
                        this._spinnerService.hideSpinner();
                        console.error(error);
                    }
                )
            );
    }

    

    private handleError(error: Response | any) {
        if(!environment.production)
        {
            console.log(error);
        }
        // In a real world app, we might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            console.log(err);
            if (body.error == 'invalid_grant' || body.error == "auth_error") {
                errMsg = `${body.error_description} `;
            }
            else {
                errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            }
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throwError(errMsg);
    }

    public logout() {
        localStorage.removeItem('token');
    }
}